import { FilterCondition } from '@/features/analyze/types';

type OrConditionKey = keyof Pick<
  FilterCondition,
  | 'organizations'
  | 'organizationTypes'
  | 'countries'
  | 'countryTags'
  | 'themes'
  | 'topicTags'
>;

type OrConditionValue = string | string[];

export const buildOrFilterCondition = (
  values: Partial<Record<OrConditionKey, OrConditionValue>>
): FilterCondition => {
  const condition: FilterCondition = {};

  (Object.entries(values) as [OrConditionKey, OrConditionValue][])
    .filter(([, value]) => value != null)
    .forEach(([key, value]) => {
      const normalized = Array.isArray(value) ? value : [value];
      if (normalized.length === 0) return;
      condition[key] = { or: normalized };
    });

  return condition;
};
